module.exports = __webpack_public_path__ + "static/media/entregapersona.f563068e.svg";